export default {
  DARK: {
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    counter: p => p.primaryLight,
    stepTitle: p => p.tertiaryDark,
    stepDescription: p => p.tertiaryNormal,
    background: p => `${p.tertiaryDark}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    background: p => `${p.tertiaryLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    counter: p => p.primaryDark,
    stepTitle: p => p.tertiaryDark,
    stepDescription: p => p.tertiaryNormal
  },
  EXTRALIGHT: {
    background: p => `${p.tertiaryExtraLight}`,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    counter: p => p.primaryDark,
    stepTitle: p => p.tertiaryDark,
    stepDescription: p => p.tertiaryNormal
  }
}
